import { getEmailSchema } from 'utils/schema';
import * as yup from 'yup';
import { TRequestResetPasswordFormValues } from './RequestResetPassword.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getRequestResetPasswordSchema = (localize: TLocalize) =>
  yup.object<TRequestResetPasswordFormValues>().shape({
    email: getEmailSchema(localize).required(
      localize('validation.email.required') as string
    ),
  });
